import { render, staticRenderFns } from "./RealEstatePage.vue?vue&type=template&id=32fca640&scoped=true&"
import script from "./RealEstatePage.vue?vue&type=script&lang=js&"
export * from "./RealEstatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32fca640",
  null
  
)

export default component.exports